import { render } from "./AdminInfo.vue?vue&type=template&id=d16a5e30&scoped=true"
import script from "./AdminInfo.vue?vue&type=script&lang=js"
export * from "./AdminInfo.vue?vue&type=script&lang=js"

import "./AdminInfo.vue?vue&type=style&index=0&id=d16a5e30&scoped=true&lang=css"

import exportComponent from "/Users/mark/Documents/vs_workspaces/sadc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d16a5e30"]])

export default __exports__